import { createFileRoute } from '@tanstack/react-router'
import { FaqPage } from '@/components/infoPages/FaqPage'

export const Route = createFileRoute('/faq')({
  component: FaqPage,
})

